import { useQueryClient } from '@tanstack/react-query';
export function createCallRepository(config) {
    const { repository, client: api } = config.config;
    const PREFIX = ['conversations', 'call'];
    // Helper function to generate consistent query keys
    const getQueryKey = (context) => [
        ...PREFIX,
        context.principal?.id,
    ];
    return {
        useCreate(context) {
            const client = useQueryClient();
            const mutation = repository.useMutation(context, {
                async mutationFn(props) {
                    const response = await api.callCreate({
                        callCreateRequest: props,
                    }, {
                        headers: {
                            Authorization: `Bearer ${context.token}`,
                        },
                    });
                    if (response.data.closed) {
                        console.log('thread was closed from call, refetching...', response.data.thread);
                        await repository.thread.refetch(context, client, response.data.thread);
                        // NOTE its important that we also refetch the list cache entry to ensure
                        // side-effects from calling conversation tools are reflected in the local state as well
                        await repository.thread.refetch(context, client, null);
                    }
                    return response.data;
                },
            });
            return mutation;
        },
    };
}
//# sourceMappingURL=assistantCallRepository.js.map